import { SBTranslate } from "i18n";
import { IInventoryPositionResponse } from "domain/Inventory/Models/IInventoryPositionResponse";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SBSummarization from "views/Commons/SBSummarization";

interface InventoryPositionSummarizationProps {
	items: IInventoryPositionResponse[];
	selectedItems?: IInventoryPositionResponse[];
}

export const InventoryPositionSummarization = ({
	items,
	selectedItems,
}: InventoryPositionSummarizationProps) => {
	const { i18n } = useTranslation();

	const sum = (list: IInventoryPositionResponse[], field: keyof IInventoryPositionResponse) =>
		list.reduce((acc, item) => acc + ((item[field] as number) || 0), 0);

	const hasSelected = !!selectedItems && selectedItems.length > 0;

	const summarizations = useMemo(
		() => [
			{
				name: SBTranslate("onHand"),
				tip: SBTranslate("tips.onHand"),
				icon: "package",
				color: "darkPurple",
				value: sum(items, "onHand"),
				selectedItems: hasSelected
					? sum(selectedItems!, "onHand")
					: undefined,
			},
			{
				name: SBTranslate("onOrder"),
				tip: SBTranslate("tips.onOrder"),
				icon: "package",
				color: "darkPurple",
				value: sum(items, "onOrder"),
				selectedItems: hasSelected
					? sum(selectedItems!, "onOrder")
					: undefined,
			},
			{
				name: SBTranslate("commons.pending"),
				tip: SBTranslate("tips.pending"),
				icon: "package",
				color: "darkPurple",
				value: sum(items, "reserved"),
				selectedItems: hasSelected
					? sum(selectedItems!, "reserved")
					: undefined,
			},
		],
		[items, selectedItems, i18n.language],
	);

	if (!items || items.length === 0) return null;

	return <SBSummarization items={summarizations} withShadow />;
};
